export class BrandLogosSortField {
    static readonly LogoUrl: number = 1;
    static readonly Height: number = 2;
    static readonly Width: number = 3;
}


// WEBPACK FOOTER //
// ./src/app/brand-logos/brand-logos-sort.enum.ts